const getDefaultState = () => ({
  showFullLoading: false
});

const state = getDefaultState();

const mutations = {
  SET_FULL_LOADING: (state, data) => {
    // console.log(data)
    state.showFullLoading = data;
  },
  INIT_FULL_LOADING: (state, data) => {
    state.showFullLoading = data;
    // localStorage.setItem('cacheViews', JSON.stringify(state.cacheViews))
  }
};

const actions = {
  setFullLoading({ commit, state }, data) {
    commit("SET_FULL_LOADING", data);
  },
  initFullLoading({ commit, state }, data) {
    // console.log(data)
    commit("INIT_FULL_LOADING", data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
